export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'
      }
    },
    {
      title: true,
      name: 'TAKUBO WEB',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'SWANサイト',
      url: '/swan',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'トップページ',
          url: '/swan/top/',
          icon: 'icon-puzzle'
        },
        {
          name: 'スライド一覧',
          url: '/swan/top_slide',
          icon: 'icon-puzzle'
        },
        {
          name: 'レイヤー一覧',
          url: '/swan/layer',
          icon: 'icon-puzzle'
        },
        {
          name: 'SWAN ニュース',
          url: '/swan/news/',
          icon: 'icon-puzzle'
        },
        {
          name: 'SWAN Proとは',
          url: '/swan/overview/',
          icon: 'icon-puzzle'
        },
        {
          name: '機能・特徴',
          url: '/swan/feature/',
          icon: 'icon-puzzle'
        },
        {
          name: '対応ワーク',
          url: '/swan/work/',
          icon: 'icon-puzzle'
        },
        {
          name: '技術情報',
          url: '/swan/techInfo/',
          icon: 'icon-puzzle'
        },
        {
          name: 'FAQ',
          url: '/swan/faq/',
          icon: 'icon-puzzle'
        },
        {
          name: 'お問い合わせ',
          url: '/swan/contact/',
          icon: 'icon-puzzle'
        },
        {
          name: '消耗品オーダー',
          url: '/swan/order/',
          icon: 'icon-puzzle'
        },
        {
          name: '固定ページ',
          url: '/swan/static/',
          icon: 'icon-puzzle'
        },
        {
          name: 'サイト設定',
          url: '/swan/setting/',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      divider: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js